import { z } from 'zod';
import { tradeSchema } from './ITrade';
import { UtilityTypes } from '../constants/utilityTypes.enum';
import { IMinimizedProfession, minimizedProfessionSchema } from './IMinimizedProfession';

// Schemas (source of truth)
export const utilitySchema = tradeSchema.extend({
	_id: z.string(),
	type: z.enum(UtilityTypes),
	projectId: z.string(),
	profession: minimizedProfessionSchema.optional(),
	name: z.string().optional(),
});

// Types (derived from schema)
type IUtilityBase = Omit<z.infer<typeof utilitySchema>, 'profession' | 'name'>;

export type IHoistUtility = IUtilityBase;

export type IScissorsLiftUtility<T extends IMinimizedProfession = IMinimizedProfession> = IUtilityBase & {
	profession: T;
	name: string;
};

export type IUtility<T extends IMinimizedProfession = IMinimizedProfession> = IHoistUtility | IScissorsLiftUtility<T>;
